<template>
    <common-panel
            v-model="value"
            :image="image"
            :is-read-only="readOnly"
            :width-style="widthStyle"
            :related-url="relatedUrl"
            :validation-lists="validationLists"
            :translate-obj="translateObj"
            :element-author-display="elementAuthorDisplay"
            @close="closePanel"
            @changeTranslate="changeTranslate"
            v-on:update:members="value.members = $event"
    >

        <template slot="t-description-text">
            이벤트의 내용을 정의하고 시스템의 경계를 구분.
        </template>

        <template slot="t-generation-text">
            Bounded Contexts become a name of the files
        </template>


        <template slot="t-edit-user">
            <div
                    v-if="newEditUserImg.length > 0 && readOnly"
                    style="text-align:center"
            >
                <v-chip
                        small
                        color="orange"
                        text-color="white"
                        style="font-weight:bold;">
                    <v-avatar left>
                        <v-icon>mdi-lead-pencil</v-icon>
                    </v-avatar>
                    {{newEditUserImg[0].name}} is now editing...
                </v-chip>
            </div>
        </template>

        <template slot="element">
            <div>
                <v-card flat>
                    <v-card-text>
                        <v-autocomplete
                                v-if="selectedTemplateLists"
                                v-model="value.preferredPlatform"
                                :items="selectedTemplateLists"
                                item-text="display"
                                item-value="template"
                                :disabled="readOnly"
                                label="Preferred Platform"
                        ></v-autocomplete>

                        <v-autocomplete
                                v-model="value.members"
                                :items="userLists"
                                filled
                                chips
                                color="blue-grey lighten-2"
                                label="Select"
                                item-text="userName"
                                return-object
                                :multiple="true"
                        >
                            <template v-slot:selection="data">
                                <v-chip
                                        v-bind="data.attrs"
                                        :input-value="data.selected"
                                        close
                                        @click="data.select"
                                        @click:close="remove(data.item)"
                                >
                                    <v-avatar left>
                                        <v-img :src="data.item.userPic"></v-img>
                                    </v-avatar>
                                    {{ data.item.userName }}
                                </v-chip>
                            </template>
                        </v-autocomplete>

                        <v-text-field
                                v-model="value.gitURL"
                                label="gitURL"
                                filled
                        ></v-text-field>
                    </v-card-text>
                </v-card>

                <v-card flat v-if="value.members">
                    <v-card-text>
                        <div>
                            <v-data-table
                                    :headers="userTableHeaders"
                                    :items="value.members"
                                    class="elevation-1"
                            >
                                <template v-slot:item.readable="{ item }">
                                    <v-simple-checkbox
                                            v-model="item.readable"
                                            :ripple="false"
                                    ></v-simple-checkbox>
                                </template>
                                <template v-slot:item.writable="{ item }">
                                    <v-simple-checkbox
                                            v-model="item.writable"
                                            :ripple="false"
                                    ></v-simple-checkbox>
                                </template>
                                <template v-slot:item.admin="{ item }">
                                    <v-simple-checkbox
                                            v-model="item.admin"
                                            :ripple="false"
                                    ></v-simple-checkbox>
                                </template>
                            </v-data-table>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </template>
    </common-panel>
</template>


<script>
    import CommonPanel from "./CommonPanel";
    import EventStormingModelPanel from "../EventStormingModelPanel";

    export default {
        mixins: [EventStormingModelPanel],
        name: 'boundedcontext-panel',
        components: {
            CommonPanel
        },
        data() {
            return {
                userTableHeaders: [
                    {
                        text: 'Name',
                        align: 'start',
                        sortable: false,
                        value: 'userName',
                    },
                    {
                        text: 'Readable',
                        value: 'readable',
                    },
                    {
                        text: 'Writable',
                        value: 'writable',
                    },
                    {
                        text: 'Admin',
                        value: 'admin',
                    }
                ],

            }
        },
        computed: {
            userLists() {
                var me = this;
                var result = [];
                if (me.canvasbase.information) {
                    if (me.canvasbase.information.permissions) {
                        var arr = Object.keys(me.canvasbase.information.permissions);

                        for (var key in arr) {
                            result.push(me.canvasbase.information.permissions[arr[key]]);
                        }
                    }
                }
                return result;
            },
            selectedTemplateLists() {
                var me = this
                var list = null
                if (me.canvasbase && me.canvasbase.templateList) {
                    if (!list) list = []
                    list = JSON.parse(JSON.stringify(me.canvasbase.templateList))
                    list.shift()
                    return list
                }
                return list
            },

        },
        created: function () {
            this.panelInit()
        },
        methods: {
            panelInit(){
                var me = this
                // Element
                me.relatedUrl = 'https://intro-kor.msaez.io/tool/event-storming-tool/#%C2%B7-bounded-context-sticker'

                // Common
                me.$super(EventStormingModelPanel).panelInit()

            }
        }
    }
</script>
